export const splitArr = <T>(arr: T[], length: number) => {
  const result = [];

  for (let i = 0; i < arr.length; i += length) {
    result.push(arr.slice(i, i + length));
  }

  return result;
};
